export const START_ANNOTATION = 'START_ANNOTATION'
export const END_ANNOTATION = 'END_ANNOTATION'
export const ANNOTATION_TYPE_OFF = 'ANNOTATION_TYPE_OFF'
export const ANNOTATION_TYPE_POINT = 'ANNOTATION_TYPE_POINT'
export const ANNOTATION_TYPE_LINESTRING = 'ANNOTATION_TYPE_LINESTRING'
export const ANNOTATION_TYPE_POLYGON = 'ANNOTATION_TYPE_POLYGON'

// annotationInfo.titleid: Layer titleid
// annotationInfo.type: ANNOTATION_TYPE_X
export const startAnnotation = annotationInfo => ({
  type: START_ANNOTATION,
  annotationInfo
})

export const endAnnotation = () => ({
  type: END_ANNOTATION,
  annotationInfo: null
})
